<template>
    <div id="log-report">
        <div id="page-head">
            <ul id="breadcrumbs">
                <li><router-link :to="{ name: 'Dashboard' }">Dashboard</router-link></li>
                <li><router-link :to="{ name: 'BudgetIndex' }">Budget Manager</router-link></li>
                <li>Log Report</li>
            </ul>
        </div>

        <div class="panel">
            <div class="panel-head">
                <h2>Log Report</h2>
            </div>
            <div class="panel-content">

                <loading v-if="loading"></loading>
                <div v-else v-for="budget in budgets">
                    <h3 class="client-name">{{ budget.client.name }}</h3>
                    <p class="logs" v-if="budget.client.paid_media_logs.length == 0"><em>No Logs</em></p>
                    <ul class="logs" v-else>
                        <li v-for="log in budget.client.paid_media_logs">
                            <span class="type" :class="log.type.toLowerCase().split(' ').join('-')">{{ log.type }}</span>
                            <span class="description">{{ log.description }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/ui/Loading'

export default {
    name: 'LogReport',
    components: {
        Loading
    },
    data() {
        return {
            budgets: [],
            loading: true
        }
    },
    async created() {
        let response = await this.$http.get('/paid-media-budgets', { params: { year: this.getYear, month: this.getMonth }})
        this.budgets = response.data
        this.loading = false
    },
    computed: {
        ...mapGetters([
            'getYear',
            'getMonth'
        ])
    }
}
</script>

<style lang="scss">
#log-report {
    .client-name {
        font-size: 20px;
    }

    .logs {
        margin-left: 15px;
        padding-bottom: 30px;
        margin-bottom: 15px;
        border-bottom: 1px solid $light-gray;

        li {
            margin: 5px 0;
        }

        .type,
        .description {
            display: inline-block;
        }

        .type {
            margin-right: 5px;
            padding: 5px 10px;
            font-weight: 700;
            font-size: 12px;
            color: $white;
            border-radius: 5px;
            width: 100px;
            text-align: center;

            &.cancellation {
                background: $red;
            }

            &.followup {
                background: $green;
            }

            &.billing-hold {
                background: $orange;
            }

            &.notes {
                background: $blue;
            }
        }
    }
}
</style>
